import { InjectionToken, Signal } from "@angular/core";
import { AppNavigation } from "../types/navigation.types";

/**
 * The navigation injection token.
 */
export const NAVIGATION = new InjectionToken<Signal<AppNavigation>>('NAVIGATION');